{
  "fieldList": {
    "addField": {
      "label": "Agregar Campo",
      "placeholder": "Nombre del campo",
      "typeLabel": "Tipo",
      "addButton": "Agregar"
    },
    "search": {
      "placeholder": "Buscar campos..."
    },
    "filters": {
      "all": "todos",
      "mapped": "asignados",
      "unmapped": "no asignados"
    },
    "actions": {
      "rename": "Renombrar campo",
      "clone": "Clonar campo",
      "delete": "Eliminar campo"
    },
    "deleteDialog": {
      "title": "Eliminar Campo",
      "body": "¿Está seguro(a) de que desea eliminar el campo \"{{fieldName}}\"?"
    },
    "validation": {
      "fieldNameRequired": "El nombre del campo es obligatorio",
      "invalidFieldName": "Nombre de campo no válido"
    },
    "empty": "No se encontraron campos",
    "accordion": {
      "summary": "Campos ({{mappedCount}}/{{totalCount}} asignados)"
    },
    "typeOverride": {
      "chip": "→ {{type}}"
    }
  },
  "batchUpload": {
    "title": "Subida Masiva de Campos",
    "button": "Subida Masiva",
    "uploadStep": "Subir un archivo CSV",
    "selectFieldNameColumn": "Seleccione la columna que contiene los nombres de los campos",
    "selectFieldTypeColumn": "Columna de tipo de campo (opcional)",
    "mappingHelpText": "Asigne cada columna a un destino antes de continuar. Solo una columna puede asignarse a Nombre del Campo, y como máximo una puede asignarse a Tipo de Campo.",
    "previewRowsHint": "Mostrando las primeras {{count}} filas de un total de {{total}} filas",
    "none": "Ninguno",
    "fileLoaded": "Archivo cargado: {{fileName}}",
    "stepLabel": "Paso {{current}} de {{total}}",
    "emptyNameValue": "(vacío)",
    "nextButton": "Siguiente",
    "backButton": "Atrás",
    "cancelButton": "Cancelar",
    "importButton": "Importar Campos",
    "status": {
      "willAdd": "Se agregará",
      "duplicateExisting": "Duplicado (omitir)",
      "duplicateCsv": "Duplicado en CSV (omitir)",
      "emptyName": "Nombre vacío (omitir)",
      "unknownType": "Tipo desconocido \"{{rawType}}\" (predeterminado a Campo de Texto)"
    },
    "preview": {
      "title": "Vista Previa",
      "fieldsToAdd": "Se agregarán {{count}} campos",
      "duplicatesSkipped": "Se omitirán {{count}} duplicados",
      "unknownTypeDefaulted": "{{count}} con tipo desconocido se predeterminaron a Campo de Texto",
      "columns": {
        "fieldName": "Nombre del Campo",
        "fieldType": "Tipo de Campo",
        "status": "Estado"
      }
    },
    "errors": {
      "parseFailed": "Error al analizar el archivo CSV"
    },
    "mappingOptions": {
      "ignore": "Ignorar",
      "fieldName": "Nombre del Campo",
      "fieldType": "Tipo de Campo"
    }
  },
  "fieldMapping": {
    "fieldType": {
      "label": "Tipo de Campo"
    },
    "typeOverridden": "(anulado)",
    "advanced": {
      "label": "Avanzado"
    },
    "dataMasking": {
      "label": "Enmascaramiento de Datos",
      "noRules": "Aún no se han añadido reglas de enmascaramiento.",
      "addRule": "Añadir regla de enmascaramiento",
      "optionColumn": "Opción",
      "pdfExportOnValueColumn": "Valor de exportación de PDF activado",
      "maskValueColumn": "Valor de enmascaramiento",
      "exactValuePlaceholder": "Valor exacto",
      "maskValuePlaceholder": "Introduzca el valor de enmascaramiento",
      "resetMask": "Restablecer máscara al valor de PDF activado"
    },
    "formatter": {
      "label": "Formateador"
    },
    "defaultValue": {
      "label": "Valor Predeterminado",
      "placeholder": "Alternativa si está vacío"
    },
    "errorWhenEmpty": {
      "label": "Error si está vacío"
    }
  },
  "settings": {
    "moreSettings": "Más configuraciones",
    "title": "Configuración del mapa de formulario",
    "esignSection": "Firma electrónica",
    "pdfSection": "Salida PDF",
    "signaturePageNumberBase": {
      "label": "Base del número de página de la firma",
      "help": "Use UNO para DocuSign, CERO para OneSpan",
      "one": "UNO (basado en 1)",
      "zero": "CERO (basado en 0)"
    },
    "removePdfMaxLength": {
      "label": "Eliminar longitud máxima de PDF"
    },
    "language": {
      "label": "Idioma",
      "options": {
        "en": "Inglés",
        "es": "Español",
        "fr": "Francés"
      }
    }
  },
  "testPanel": {
    "eSignProvider": {
      "label": "Proveedor de Firma Electrónica",
      "helpText": "Sistema de coordenadas utilizado para las ubicaciones de los campos de firma",
      "options": {
        "rawPdf": "PDF sin procesar (inferior izquierda, 72 DPI)",
        "docusign": "DocuSign (superior izquierda, 72 DPI)",
        "onespan": "OneSpan (superior izquierda, 93.6 DPI)"
      }
    },
    "signatureFieldLocations": {
      "title": "Ubicaciones de los Campos de Firma"
    }
  },
  "replacePdf": {
    "button": "Reemplazar PDF",
    "unsavedLabel": "PDF sin guardar",
    "revert": "Revertir",
    "confirmTitle": "¿Reemplazar PDF de plantilla?",
    "confirmCurrent": "Actual: {{file}}",
    "confirmNew": "Nuevo: {{file}}",
    "confirmMatchHeading": "Coincidencia de campos con este mapa:",
    "confirmKept": "{{count}} etiquetas aún en el nuevo PDF (conservadas)",
    "confirmMissing": "{{count}} etiquetas faltantes en el nuevo PDF (conservadas como extras)",
    "confirmAdded": "{{count}} nuevos widgets sin asignación (vacíos)",
    "confirmFooter": "Las asignaciones de campos existentes se fusionarán por nombre. El nuevo PDF no se guarda hasta que haga clic en Actualizar.",
    "errorReading": "Error al leer el PDF. Asegúrese de que tenga campos de formulario rellenables."
  }
}
